"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.concat.js");
var _packingSlips = require("./packingSlips");
var _handlers = require("./handlers");
var _state = require("./state");
var _mttPostal = _interopRequireDefault(require("@gaming/mtt-postal"));
var _lodashReplacement = _interopRequireDefault(require("./lodashReplacement"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var extendLodash = _lodashReplacement.default.extend,
  without = _lodashReplacement.default.without,
  clone = _lodashReplacement.default.clone;
var FederationClient = /*#__PURE__*/function () {
  function FederationClient(target, options, instanceId) {
    _classCallCheck(this, FederationClient);
    this.target = target;
    this.options = options || {};
    this.pings = {};
    this.instanceId = instanceId;
    this.handshakeComplete = false;
  }
  _createClass(FederationClient, [{
    key: "sendPing",
    value: function sendPing(callback) {
      var packingSlip = (0, _packingSlips.getPackingSlip)("ping");
      this.pings[packingSlip.ticket] = {
        ticket: packingSlip.ticket,
        callback: callback || _state.NO_OP
      };
      this.send(packingSlip);
    }
  }, {
    key: "sendPong",
    value: function sendPong(origPackingSlip) {
      this.send((0, _packingSlips.getPackingSlip)("pong", origPackingSlip));
    }
  }, {
    key: "sendBundle",
    value: function sendBundle(slips) {
      this.send((0, _packingSlips.getPackingSlip)("bundle", slips));
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(envelope) {
      if (!this.handshakeComplete) {
        return;
      }
      envelope.originId = envelope.originId || _mttPostal.default.instanceId();
      var env = clone(envelope);
      if (this.instanceId && this.instanceId !== env.lastSender && (!env.knownIds || !env.knownIds.length || env.knownIds && !env.knownIds.includes(this.instanceId))) {
        env.knownIds = (env.knownIds || []).concat(without(_state.state._clients, this.instanceId));
        this.send((0, _packingSlips.getPackingSlip)("message", env));
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.send((0, _packingSlips.getPackingSlip)("disconnect"));
    }
  }, {
    key: "onMessage",
    value: function onMessage(packingSlip) {
      if (this.shouldProcess()) {
        (0, _handlers.onFederatedMsg)({
          transport: this.transportName,
          packingSlip: packingSlip,
          source: this
        });
      }
    }
  }, {
    key: "shouldProcess",
    value: function shouldProcess() {
      return true;
    }
  }, {
    key: "send",
    value: function /* msg */
    send() {
      throw new Error("An object deriving from FederationClient must provide an implementation for 'send'.");
    }
  }, {
    key: "setInstanceId",
    value: function setInstanceId(id) {
      this.instanceId = id;
    }
  }], [{
    key: "extend",
    value: function extend(props, ctrProps) {
      function FedXClient() {
        FederationClient.apply(this, arguments);
      }
      FedXClient.prototype = Object.create(FederationClient.prototype);
      extendLodash(FedXClient.prototype, props);
      extendLodash(FedXClient, ctrProps);
      return FedXClient;
    }
  }]);
  return FederationClient;
}();
exports.default = FederationClient;